import { Word } from '../components/new-portal/ai-tutor/Common'
import { n_ai_tutor } from '../modules/i18n/strings/auto/wording'

export const activityOrder = [
  'ExplanationActivity',
  'ListenAndRepeatActivity',
  'FillInTheBlankActivity',
  'FillInTheBlankSpeakingActivity',
  'ChooseCorrectSentenceActivity',
  'MiniRoleplayActivity',
]

export const ACTIVITY_WORDING = {
  ExplanationActivity: n_ai_tutor.study_activity.status_step1,
  ListenAndRepeatActivity: n_ai_tutor.study_activity.status_step2,
  FillInTheBlankActivity: n_ai_tutor.study_activity.status_step3,
  FillInTheBlankSpeakingActivity: n_ai_tutor.study_activity.status_step4,
  ChooseCorrectSentenceActivity: n_ai_tutor.study_activity.status_step5,
  MiniRoleplayActivity: n_ai_tutor.study_activity.status_step6,
}

export const SEPARATORS = [',', '.', '!', '?', `'`, `"`, `'`, `’`]

export function purify(sentence: string) {
  return sentence
    .replace(/[^\w\s]/g, '')
    .trim()
    .toLowerCase()
}

export function parseStringToObjects(sentence: string, keywords: string[]): Word[] {
  const parsed = parseSentence(sentence, keywords || [])

  const regex = /\w+|[^\w\s]|\s+/g

  return parsed.flatMap((e, ei) => {
    const matches: string[] = e.content.match(regex) || []

    return matches
      .filter((i) => i.trim())
      .map((w, index, array) => {
        const isSeparator = SEPARATORS.includes(w)

        let startOffset = 0
        for (let i = 0; i < ei; i++) {
          startOffset = sentence.indexOf(parsed[i].content, startOffset) + parsed[i].content.length
          while (sentence[startOffset] === ' ') startOffset++
        }
        for (let i = 0; i < index; i++) {
          startOffset = sentence.indexOf(array[i], startOffset) + array[i].length
          while (sentence[startOffset] === ' ') startOffset++
        }
        const endOffset = startOffset + w.length

        const result: Word = {
          word: w,
          keyword: e.key && !isSeparator,
          separator: isSeparator,
          ps: startOffset > 0 && sentence[startOffset - 1] === ' ',
          ns: endOffset < sentence.length && sentence[endOffset] === ' ',
        }

        return result
      })
  })
}

export function parseSentence(sentence: string, keywords: string[]) {
  const ranges = [] as { start: number; end: number }[]

  ;[...keywords, '__'].forEach((keyword) => {
    const regex = new RegExp(purify(keyword), 'g')
    let match

    while ((match = regex.exec(sentence)) !== null) {
      let start = match.index
      let end = start + match[0].length

      while (start > 0 && sentence[start - 1] !== ' ') {
        start--
      }

      while (end < sentence.length && sentence[end] !== ' ') {
        end++
      }

      ranges.push({ start, end })
    }
  })

  ranges.sort((a, b) => a.start - b.start)
  const mergedRanges = []

  ranges.forEach((range) => {
    if (mergedRanges.length > 0 && range.start <= mergedRanges[mergedRanges.length - 1].end) {
      mergedRanges[mergedRanges.length - 1].end = Math.max(mergedRanges[mergedRanges.length - 1].end, range.end)
    } else {
      mergedRanges.push(range)
    }
  })

  const result = [] as { content: string; key: boolean; range: { start: number; end: number } }[]
  let lastIndex = 0

  mergedRanges.forEach((range, index) => {
    if (range.start > lastIndex) {
      const content = sentence.slice(lastIndex, range.start).trim()
      if (content.length > 0) {
        result.push({
          content,
          key: false,
          range: { start: lastIndex, end: range.start },
        })
      }
    }
    const content = sentence.slice(range.start, range.end).trim()
    result.push({
      content,
      key: true,
      range: { start: range.start, end: range.end },
    })
    lastIndex = range.end
  })

  if (lastIndex < sentence.length) {
    const content = sentence.slice(lastIndex).trim()
    if (content.length > 0) {
      result.push({
        content,
        key: false,
        range: { start: lastIndex, end: sentence.length },
      })
    }
  }

  return result
}
